export const typeOptions = [
  {
    label: 'New',
    value: 'new',
  },
  {
    label: 'Renew',
    value: 'renew',
  },
];

export const visibilityOptions = [
  {
    label: 'Visible',
    value: true,
  },
  {
    label: 'Not visible',
    value: false,
  },
];

export const holderAuthorizeOptions = [
  {
    label: 'Authorized',
    value: true,
  },
  {
    label: 'Not authorized',
    value: false,
  },
];

export const statusOptions = [
  {
    label: 'Active',
    value: 1,
  },
  {
    label: 'Withdraw By Holder',
    value: 2,
  },
  {
    label: 'Withdraw By CB',
    value: 3,
  },
];

